/* Craftmark tape builder (snippets/cm-tape-builder.liquid, buy_config "builder":"tape")
   Live, true-to-scale preview for roll tapes: DetectaMark detectable underground tape and
   Non-Potable pipe marking tape (stock legends and custom legends).
   View 1: the roll with tape pulled off it, showing full legend repeats.
   View 2: how it is used (detectable: buried above the utility; vinyl: run along the pipe). */
(function () {
  'use strict';
  var cfgEl = document.getElementById('cm-tape-cfg');
  if (!cfgEl) return;
  var CFG = {}; try { CFG = JSON.parse(cfgEl.textContent) || {}; } catch (e) {}
  var T = CFG.tape || {};
  var NS = 'http://www.w3.org/2000/svg';
  var FONT = '"Helvetica Bold Craftmark", "Helvetica Neue", Helvetica, Arial, sans-serif';
  var COLORS = {
    black: '#111111', white: '#ffffff', orange: '#f68712', gray: '#a3a2a0', grey: '#a3a2a0', green: '#00a650',
    blue: '#3871c1', red: '#ed1c24', yellow: '#fff200', purple: '#9e38a1', brown: '#7a4b24'
  };
  function col(name, fallback) {
    if (!name) return fallback;
    var k = String(name).trim().toLowerCase();
    if (k.charAt(0) === '#') return k;
    return COLORS[k] || fallback;
  }
  function el(n, a, p) {
    var e = document.createElementNS(NS, n);
    for (var k in a) if (a[k] != null) e.setAttribute(k, a[k]);
    if (p) p.appendChild(e);
    return e;
  }
  function uid() { return 'cmt' + Math.random().toString(36).slice(2, 8); }
  function clear(svg) { while (svg.firstChild) svg.removeChild(svg.firstChild); }
  function shade(hex, amt) {
    var h = hex.replace('#', ''); if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
    var n = parseInt(h, 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
    function f(c) { return Math.max(0, Math.min(255, Math.round(amt < 0 ? c * (1 + amt) : c + (255 - c) * amt))); }
    return '#' + ((1 << 24) + (f(r) << 16) + (f(g) << 8) + f(b)).toString(16).slice(1);
  }

  // ---- form state ----
  function optSel(name) {
    var s = document.querySelector('.product_option_select[data-option-label="' + name + '"]');
    return s;
  }
  function optVal(name) { var s = optSel(name); return s ? s.value : ''; }
  function widthIn() {
    var v = optVal(T.sizeOption || 'Size'), m = /([\d.]+)\s*(?:"|”|in)/.exec(v) || /([\d.]+)/.exec(v);
    return m ? parseFloat(m[1]) : (T.defaultWidth || 3);
  }
  function currentVariant() {
    var idEl = document.getElementById('product_id'), id = idEl ? String(idEl.value) : '';
    var list = window.variants || [];
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === id) return list[i];
    // fall back to matching the visible options
    var sels = [].slice.call(document.querySelectorAll('.product_option_select'));
    for (var j = 0; j < list.length; j++) {
      var ok = sels.every(function (s, k) { return !s.value || s.value === '0' || list[j].options[k] === s.value; });
      if (ok) return list[j];
    }
    return null;
  }
  function textInput() { return document.querySelector('[data-text-line="1"]'); }
  function state() {
    var st = { width: widthIn(), len: T.lengthFt || 100, kind: T.kind || 'vinyl', ghost: false };
    if (T.legendOption) {
      var lv = optVal(T.legendOption), L = (T.legends || {})[lv] || {};
      st.legend = L.text || String(lv).split(' — ')[0].split(' – ')[0].trim();
      st.bg = col(L.bg, '#fff200'); st.fg = col(L.fg, '#111111');
      st.picto = !!L.picto;
    } else {
      var ti = textInput(), raw = ti ? ti.value : '';
      st.legend = String(raw).toUpperCase().replace(/\s+/g, ' ').trim();
      if (!st.legend) { st.legend = T.placeholder || 'YOUR LEGEND HERE'; st.ghost = true; }
      var cs = document.querySelector('select[name="properties[' + (T.colorProp || 'Color') + ']"]');
      st.bg = col(cs && cs.value, col(T.defaultBg, '#9e38a1'));
      var tc = document.getElementById('text_color');
      st.fg = col(tc && tc.value, '#111111');
      var pc = document.getElementById('cm_tape_picto');
      st.picto = !!(pc && pc.checked);
    }
    var v = currentVariant();
    st.sku = v && v.sku ? v.sku : '';
    return st;
  }

  // ---- drawing helpers ----
  var measureSvg = null;
  function textWidth(str, size, condensed) {
    if (!measureSvg) {
      measureSvg = el('svg', { width: 10, height: 10, style: 'position:absolute;left:-9999px;top:-9999px;visibility:hidden' });
      document.body.appendChild(measureSvg);
    }
    var t = el('text', { x: 0, y: 50, 'font-family': FONT, 'font-weight': 700, 'font-size': size }, measureSvg);
    t.textContent = str;
    var w = 0; try { w = t.getComputedTextLength(); } catch (e) {}
    measureSvg.removeChild(t);
    if (!w) w = str.length * size * 0.62;
    return w * (condensed || 1);
  }
  // text drawn left-aligned at x, vertically centred on cy; cap height = capPx; condensed = horizontal squeeze
  function drawText(g, str, x, cy, capPx, color, condensed, opacity) {
    var size = capPx / 0.72, sx = condensed || 1;
    var t = el('text', {
      x: 0, y: 0, 'font-family': FONT, 'font-weight': 700, 'font-size': size.toFixed(2), fill: color,
      transform: 'translate(' + x.toFixed(2) + ',' + (cy + capPx / 2).toFixed(2) + ') scale(' + sx + ',1)'
    }, g);
    if (opacity != null) t.setAttribute('opacity', opacity);
    t.textContent = str;
    return t;
  }
  // "do not drink" pictogram: drinking glass inside a red prohibition circle on white
  function pictogram(g, cx, cy, d) {
    var r = d / 2, sw = Math.max(1.2, d * 0.09);
    el('circle', { cx: cx, cy: cy, r: r, fill: '#ffffff' }, g);
    var gw = d * 0.34, gh = d * 0.46, top = cy - gh / 2, bot = cy + gh / 2;
    el('path', { d: 'M' + (cx - gw / 2) + ',' + top + ' L' + (cx + gw / 2) + ',' + top + ' L' + (cx + gw * 0.36) + ',' + bot + ' L' + (cx - gw * 0.36) + ',' + bot + ' Z', fill: '#111111' }, g);
    el('path', { d: 'M' + (cx - gw * 0.44) + ',' + (top + gh * 0.28) + ' L' + (cx + gw * 0.44) + ',' + (top + gh * 0.28) + ' L' + (cx + gw * 0.36) + ',' + bot + ' L' + (cx - gw * 0.36) + ',' + bot + ' Z', fill: '#3b8fd6' }, g);
    el('circle', { cx: cx, cy: cy, r: r - sw / 2, fill: 'none', stroke: '#e21b23', 'stroke-width': sw }, g);
    var a = Math.PI / 4, dx = Math.cos(a) * (r - sw), dy = Math.sin(a) * (r - sw);
    el('line', { x1: cx - dx, y1: cy - dy, x2: cx + dx, y2: cy + dy, stroke: '#e21b23', 'stroke-width': sw }, g);
  }
  // DetectaMark info block (small print next to every legend): Craftmark mark, product name, install note
  function infoBlock(g, x, y, w, h, color) {
    var line = function (str, yy, cap, cond) { drawText(g, str, x, yy, cap, color, cond); };
    var u = h / 10;
    line('CRAFTMARK', y + u * 1.4, u * 1.2, 1);
    line('UTILITY MARKING • SINCE 1959', y + u * 2.9, u * 0.55, 0.9);
    line('DetectaMark™ DETECTABLE UNDERGROUND TAPE', y + u * 4.3, u * 0.62, 0.82);
    line('INSTALLATION: SHALLOW BURY TAPE 6"–12" FROM FINISHED GRADE,', y + u * 6.0, u * 0.42, 0.85);
    line('MAXIMUM DISTANCE BETWEEN WARNING TAPE AND BURIED PIPE.', y + u * 7.0, u * 0.42, 0.85);
    line('TAPE MEETS OR EXCEEDS INDUSTRY STANDARD  www.CraftMarkID.com', y + u * 8.6, u * 0.42, 0.85);
  }

  // One repeat of the printed tape, in tape-inches. Returns {len, draw(g, x0, y0, ppi)}
  function repeatSpec(st) {
    var w = st.width;
    if (st.kind === 'detectable') {
      var band = w * 0.80, cap = band * 0.56, cond = 0.74;
      var tw = textWidth(st.legend, 100 / 0.72, cond) / 100 * cap; // in inches
      var info = Math.max(4.5, w * 1.9), gap = w * 0.45;
      return {
        len: gap + tw + gap * 0.8 + info + gap,
        draw: function (g, x0, y0, ppi) {
          var cy = y0 + w * ppi / 2;
          drawText(g, st.legend, x0 + gap * ppi, cy, cap * ppi, st.fg, cond, st.ghost ? 0.45 : null);
          infoBlock(g, x0 + (gap + tw + gap * 0.8) * ppi, cy - band * ppi * 0.42, info * ppi, band * ppi * 0.84, st.fg);
        }
      };
    }
    var capV = w * (T.capRatio || 0.42), pd = w * 0.72, gapV = w * 0.5;
    var twV = textWidth(st.legend, 100 / 0.72, 1) / 100 * capV;
    var lenV = gapV + (st.picto ? pd + gapV * 0.7 : 0) + twV + gapV;
    return {
      len: lenV,
      draw: function (g, x0, y0, ppi) {
        var cy = y0 + w * ppi / 2, x = x0 + gapV * ppi;
        if (st.picto) { pictogram(g, x + pd * ppi / 2, cy, pd * ppi); x += (pd + gapV * 0.7) * ppi; }
        drawText(g, st.legend, x, cy, capV * ppi, st.fg, 1, st.ghost ? 0.45 : null);
      }
    };
  }

  // the printed face of the tape between x0 and x1 (screen px), starting at a given phase
  function tapeFace(g, defs, st, rep, x0, y0, x1, ppi, startX) {
    var h = st.width * ppi, id = uid();
    var clip = el('clipPath', { id: id }, defs); el('rect', { x: x0, y: y0, width: x1 - x0, height: h }, clip);
    var fg = el('g', { 'clip-path': 'url(#' + id + ')' }, g);
    if (st.kind === 'detectable') {
      var fid = uid(), fl = el('linearGradient', { id: fid, x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
      [['0', '#e9edf1'], ['.12', '#9aa3ad'], ['.5', '#d9dee3'], ['.88', '#8d96a0'], ['1', '#eef1f4']].forEach(function (s) { el('stop', { offset: s[0], 'stop-color': s[1] }, fl); });
      el('rect', { x: x0, y: y0, width: x1 - x0, height: h, fill: 'url(#' + fid + ')' }, fg);
      el('rect', { x: x0, y: y0 + h * 0.1, width: x1 - x0, height: h * 0.8, fill: st.bg }, fg);
    } else {
      el('rect', { x: x0, y: y0, width: x1 - x0, height: h, fill: st.bg }, fg);
    }
    var step = rep.len * ppi, x = startX == null ? x0 : startX;
    while (x > x0) x -= step;
    while (x < x1) { rep.draw(fg, x, y0, ppi); x += step; }
    if (st.bg === '#ffffff' && st.kind !== 'detectable') el('rect', { x: x0, y: y0, width: x1 - x0, height: h, fill: 'none', stroke: '#c4c9cf', 'stroke-width': 1 }, g);
    return fg;
  }

  // ---- view 1: the roll, with the tape pulled off it to the right ----
  function drawRoll(svg, st) {
    clear(svg);
    var defs = el('defs', {}, svg), g = el('g', {}, svg);
    var rep = repeatSpec(st);
    var W = 1000, M = 24;
    var odIn = T.rollOD || 5, coreIn = T.coreOD || 3;
    // pick the scale: roll + about 1.15 legend repeats across the width, but never a tape taller than 160px
    var tilt = 0.32; // how far we look down on the roll (ellipse ry / rx)
    var ppi = (W - 2 * M) / (odIn + rep.len * 1.06);
    // long legends: keep the roll a good size and let the legend run off the edge (view 2 shows the full repeat)
    ppi = Math.max(ppi, (W * 0.24) / odIn);
    ppi = Math.min(ppi, 170 / st.width, 420 / odIn);
    var rx = odIn * ppi / 2, ry = rx * tilt, h = st.width * ppi;
    var cx = M + rx, topY = M + ry, botY = topY + h;
    var H = Math.ceil(botY + ry + M + 26);
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);

    // floor shadow
    var sid = uid(), sg = el('radialGradient', { id: sid }, defs);
    el('stop', { offset: '0', 'stop-color': '#000', 'stop-opacity': .22 }, sg); el('stop', { offset: '1', 'stop-color': '#000', 'stop-opacity': 0 }, sg);
    el('ellipse', { cx: cx + rx * 0.15, cy: botY + ry * 0.55, rx: rx * 1.15, ry: ry * 0.9, fill: 'url(#' + sid + ')' }, g);
    el('rect', { x: cx, y: botY - 2, width: W - M - cx, height: 10, fill: 'rgba(0,0,0,.08)', rx: 5 }, g);

    // the tape leaves the front of the roll and runs flat to the right
    var tapeX0 = cx, tapeX1 = W - M - 22;
    tapeFace(g, defs, st, rep, tapeX0, topY, tapeX1, ppi, cx + rx + 2);
    // a slight curl where the tape leaves the roll
    var cid = uid(), cg = el('linearGradient', { id: cid, x1: 0, y1: 0, x2: 1, y2: 0 }, defs);
    el('stop', { offset: '0', 'stop-color': '#000', 'stop-opacity': .28 }, cg); el('stop', { offset: '1', 'stop-color': '#000', 'stop-opacity': 0 }, cg);
    el('rect', { x: tapeX0, y: topY, width: Math.min(60, rx * 0.6), height: h, fill: 'url(#' + cid + ')' }, g);
    // torn/cut end of the tape
    el('path', { d: 'M' + tapeX1 + ',' + topY + ' l-6,' + (h * 0.25) + ' l6,' + (h * 0.25) + ' l-6,' + (h * 0.25) + ' l6,' + (h * 0.25), fill: 'none', stroke: 'rgba(0,0,0,.18)', 'stroke-width': 1.5 }, g);

    // roll body (outer wound layers): front half-cylinder, coloured with the tape
    var bid = uid(), bg = el('linearGradient', { id: bid, x1: 0, y1: 0, x2: 1, y2: 0 }, defs);
    [['0', 'rgba(0,0,0,.42)'], ['.18', 'rgba(0,0,0,.12)'], ['.42', 'rgba(255,255,255,.22)'], ['.62', 'rgba(255,255,255,0)'], ['.86', 'rgba(0,0,0,.18)'], ['1', 'rgba(0,0,0,.35)']].forEach(function (s) { el('stop', { offset: s[0], 'stop-color': s[1] }, bg); });
    var body = 'M' + (cx - rx) + ',' + topY + ' L' + (cx - rx) + ',' + botY + ' A' + rx + ',' + ry + ' 0 0 0 ' + (cx + rx) + ',' + botY + ' L' + (cx + rx) + ',' + topY + ' Z';
    var bodyCol = st.kind === 'detectable' ? st.bg : st.bg;
    el('path', { d: body, fill: bodyCol }, g);
    if (st.kind === 'detectable') {
      // foil edges show on the wound side of the roll
      el('path', { d: 'M' + (cx - rx) + ',' + topY + ' L' + (cx - rx) + ',' + (topY + h * 0.1) + ' A' + rx + ',' + ry + ' 0 0 0 ' + (cx + rx) + ',' + (topY + h * 0.1) + ' L' + (cx + rx) + ',' + topY + ' Z', fill: '#c9cfd5' }, g);
      el('path', { d: 'M' + (cx - rx) + ',' + (botY - h * 0.1) + ' L' + (cx - rx) + ',' + botY + ' A' + rx + ',' + ry + ' 0 0 0 ' + (cx + rx) + ',' + botY + ' L' + (cx + rx) + ',' + (botY - h * 0.1) + ' A' + rx + ',' + ry + ' 0 0 1 ' + (cx - rx) + ',' + (botY - h * 0.1) + ' Z', fill: '#b9c0c7' }, g);
    }
    el('path', { d: body, fill: 'url(#' + bid + ')' }, g);
    // top face: wound layers + core
    var faceCol = st.kind === 'detectable' ? '#d5dadf' : shade(st.bg, -0.12);
    el('ellipse', { cx: cx, cy: topY, rx: rx, ry: ry, fill: faceCol, stroke: 'rgba(0,0,0,.25)', 'stroke-width': 1 }, g);
    var coreR = coreIn / odIn;
    for (var i = 1; i <= 7; i++) {
      var f = coreR + (1 - coreR) * i / 8;
      el('ellipse', { cx: cx, cy: topY, rx: rx * f, ry: ry * f, fill: 'none', stroke: 'rgba(0,0,0,' + (0.06 + 0.02 * (i % 2)) + ')', 'stroke-width': 1 }, g);
    }
    el('ellipse', { cx: cx, cy: topY, rx: rx * coreR, ry: ry * coreR, fill: '#c8a878', stroke: '#9c7f55', 'stroke-width': 1.2 }, g);
    el('ellipse', { cx: cx, cy: topY, rx: rx * coreR * 0.84, ry: ry * coreR * 0.84, fill: '#5d5146' }, g);
    // inner wall of the core
    el('path', { d: 'M' + (cx - rx * coreR * 0.84) + ',' + topY + ' A' + (rx * coreR * 0.84) + ',' + (ry * coreR * 0.84) + ' 0 0 0 ' + (cx + rx * coreR * 0.84) + ',' + topY + ' Z', fill: '#3b332c' }, g);

    // dimension: tape width
    var dx = W - M - 6;
    el('line', { x1: dx, y1: topY, x2: dx, y2: botY, stroke: '#555', 'stroke-width': 1 }, g);
    el('line', { x1: dx - 5, y1: topY, x2: dx + 5, y2: topY, stroke: '#555', 'stroke-width': 1 }, g);
    el('line', { x1: dx - 5, y1: botY, x2: dx + 5, y2: botY, stroke: '#555', 'stroke-width': 1 }, g);
    var lt = el('text', { x: dx - 8, y: botY + 18, 'text-anchor': 'end', 'font-family': 'Helvetica, Arial, sans-serif', 'font-size': 13, fill: '#555' }, g);
    lt.textContent = fmtIn(st.width) + ' wide × ' + st.len + '′ roll';
  }
  function fmtIn(n) { return (Math.round(n * 100) / 100) + '″'; }

  // ---- view 2 (vinyl): tape run lengthwise along a pipe ----
  function drawPipe(svg, st) {
    clear(svg);
    var defs = el('defs', {}, svg), g = el('g', {}, svg);
    var rep = repeatSpec(st), W = 1000, M = 10;
    var pipeIn = Math.max(st.width * 2.4, 8);
    var ppi = Math.min((W - 2 * M) / (rep.len * 1.12), 230 / pipeIn);
    var ph = pipeIn * ppi, top = 16, H = Math.ceil(top + ph + 34);
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    var pid = uid(), pg = el('linearGradient', { id: pid, x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
    [['0', '#6f767d'], ['.2', '#c9ced3'], ['.45', '#e8ebee'], ['.75', '#a7aeb5'], ['1', '#5d646b']].forEach(function (s) { el('stop', { offset: s[0], 'stop-color': s[1] }, pg); });
    el('rect', { x: 0, y: top, width: W, height: ph, fill: 'url(#' + pid + ')' }, g);
    // tape across the front of the pipe, slightly foreshortened by the curve
    var h = st.width * ppi, y0 = top + (ph - h) / 2;
    tapeFace(g, defs, st, rep, 0, y0, W, ppi, (W - rep.len * ppi) / 2);
    var cid = uid(), cg = el('linearGradient', { id: cid, x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
    [['0', 'rgba(0,0,0,.18)'], ['.3', 'rgba(255,255,255,.18)'], ['.55', 'rgba(255,255,255,0)'], ['1', 'rgba(0,0,0,.2)']].forEach(function (s) { el('stop', { offset: s[0], 'stop-color': s[1] }, cg); });
    el('rect', { x: 0, y: y0, width: W, height: h, fill: 'url(#' + cid + ')' }, g);
    // pipe ends fade
    var fid = uid(), fg = el('linearGradient', { id: fid, x1: 0, y1: 0, x2: 1, y2: 0 }, defs);
    [['0', 1], ['.06', 0], ['.94', 0], ['1', 1]].forEach(function (s) { el('stop', { offset: s[0], 'stop-color': '#fff', 'stop-opacity': s[1] }, fg); });
    el('rect', { x: 0, y: top - 1, width: W, height: ph + 2, fill: 'url(#' + fid + ')' }, g);
    var lt = el('text', { x: W / 2, y: top + ph + 24, 'text-anchor': 'middle', 'font-family': 'Helvetica, Arial, sans-serif', 'font-size': 14, fill: '#666' }, g);
    lt.textContent = 'Shown on ' + Math.round(pipeIn) + '″ O.D. pipe, applied lengthwise';
  }

  // ---- view 2 (detectable): buried above the utility line ----
  function drawTrench(svg, st) {
    clear(svg);
    var defs = el('defs', {}, svg), g = el('g', {}, svg), W = 1000, H = 330;
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    var grade = 48;
    // soil
    var sid = uid(), sg = el('linearGradient', { id: sid, x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
    [['0', '#b08a5f'], ['1', '#7d5f3f']].forEach(function (s) { el('stop', { offset: s[0], 'stop-color': s[1] }, sg); });
    el('rect', { x: 0, y: grade, width: W, height: H - grade, fill: 'url(#' + sid + ')' }, g);
    // backfill (trench) a touch lighter
    el('path', { d: 'M330,' + grade + ' L370,' + (H - 10) + ' L630,' + (H - 10) + ' L670,' + grade + ' Z', fill: '#c39c6d', opacity: .75 }, g);
    for (var i = 0; i < 70; i++) {
      var x = (i * 137) % W, y = grade + 14 + ((i * 53) % (H - grade - 20));
      el('circle', { cx: x, cy: y, r: 1.5 + (i % 3), fill: 'rgba(60,40,20,.25)' }, g);
    }
    // grass + grade line
    el('rect', { x: 0, y: grade - 10, width: W, height: 12, fill: '#5d9a3a' }, g);
    for (var k = 0; k < W; k += 9) el('path', { d: 'M' + k + ',' + (grade - 8) + ' l3,-9 l3,9', fill: '#4b8a2c' }, g);
    var t = function (str, x, y, a, sz, c, w) { var e = el('text', { x: x, y: y, 'text-anchor': a || 'start', 'font-family': 'Helvetica, Arial, sans-serif', 'font-size': sz || 14, 'font-weight': w || 700, fill: c || '#1d1d1d' }, g); e.textContent = str; return e; };
    t('FINISHED GRADE', 20, grade - 18, 'start', 13, '#2d4a1f');
    // tape seen edge-on (6–12" below grade), with a short flat plan-view strip so the legend reads
    var tapeY = grade + 62;
    var rep = repeatSpec(st), ppi = Math.min(280 / rep.len, 26 / st.width);
    var stripW = Math.min(300, rep.len * ppi), x0 = 500 - stripW / 2;
    tapeFace(g, defs, st, rep, x0, tapeY - st.width * ppi / 2, x0 + stripW, ppi, x0);
    el('line', { x1: 360, y1: tapeY, x2: x0, y2: tapeY, stroke: st.bg, 'stroke-width': 4 }, g);
    el('line', { x1: x0 + stripW, y1: tapeY, x2: 640, y2: tapeY, stroke: st.bg, 'stroke-width': 4 }, g);
    // pipe / cable below
    var py = H - 62;
    var pid = uid(), pg = el('radialGradient', { id: pid, cx: '.4', cy: '.35' }, defs);
    el('stop', { offset: '0', 'stop-color': '#e8e8e8' }, pg); el('stop', { offset: '1', 'stop-color': '#6b6f73' }, pg);
    el('circle', { cx: 500, cy: py, r: 34, fill: 'url(#' + pid + ')', stroke: '#444', 'stroke-width': 1.5 }, g);
    el('circle', { cx: 500, cy: py, r: 24, fill: '#3a3f44' }, g);
    // callouts
    var dim = function (x, y1, y2, label) {
      el('line', { x1: x, y1: y1, x2: x, y2: y2, stroke: '#fff', 'stroke-width': 1.5, 'stroke-dasharray': '4 3' }, g);
      el('path', { d: 'M' + (x - 5) + ',' + (y1 + 7) + ' L' + x + ',' + y1 + ' L' + (x + 5) + ',' + (y1 + 7) + ' M' + (x - 5) + ',' + (y2 - 7) + ' L' + x + ',' + y2 + ' L' + (x + 5) + ',' + (y2 - 7), fill: 'none', stroke: '#fff', 'stroke-width': 1.5 }, g);
      t(label, x + 10, (y1 + y2) / 2 + 5, 'start', 13, '#fff');
    };
    dim(720, grade + 2, tapeY - 2, '6″–12″ below grade');
    t('DetectaMark™ tape', 690, tapeY + 26, 'start', 15, '#fff');
    t('Utility line', 548, py + 5, 'start', 15, '#fff');
    t('Keep the tape as far above the line as you can', 20, H - 14, 'start', 12, 'rgba(255,255,255,.9)', 400);
  }

  // ---- stats under the preview ----
  function setStat(id, v) { var e = document.getElementById(id); if (e) e.textContent = v; }

  var raf = null;
  function render() {
    raf = null;
    var st = state();
    var s1 = document.getElementById('cm_tape_svg'), s2 = document.getElementById('cm_tape_use_svg');
    if (s1) drawRoll(s1, st);
    if (s2) { if (st.kind === 'detectable') drawTrench(s2, st); else drawPipe(s2, st); }
    setStat('cm_tape_w', fmtIn(st.width));
    setStat('cm_tape_l', st.len + '′');
    if (T.legendOption) setStat('cm_tape_sku', st.sku || '—');
    else {
      var cs = document.querySelector('select[name="properties[' + (T.colorProp || 'Color') + ']"]'), tc = document.getElementById('text_color');
      setStat('cm_tape_sku', (tc ? cap(tc.value) : '') + ' on ' + (cs ? cap(cs.value) : ''));
    }
  }
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase(); }
  function queue() { if (!raf) raf = (window.requestAnimationFrame || setTimeout)(render); }

  // ---- custom legend form tweaks ----
  function setupCustom() {
    if (T.legendOption) return;
    var ti = textInput();
    if (ti) {
      ti.setAttribute('maxlength', String(T.maxChars || 70));
      ti.setAttribute('placeholder', T.placeholder || 'TYPE YOUR LEGEND');
      ti.style.textTransform = 'uppercase';
      // tapes print in capitals, so save the legend that way on the order too
      var up = function () { var s = ti.selectionStart, e2 = ti.selectionEnd, u = ti.value.toUpperCase(); if (u !== ti.value) { ti.value = u; try { ti.setSelectionRange(s, e2); } catch (x) {} } };
      ti.addEventListener('input', up); ti.addEventListener('change', up);
      var lab = ti.closest('.product_variation_field') && ti.closest('.product_variation_field').querySelector('label');
      if (lab) lab.textContent = 'Legend Text';
    }
    var cs = document.querySelector('select[name="properties[' + (T.colorProp || 'Color') + ']"]');
    if (cs) {
      var row = cs.closest('.product_variation_field'), l2 = row && row.querySelector('label');
      if (l2) l2.textContent = 'Tape Color';
      if (T.defaultBg) cs.value = T.defaultBg;
    }
    var tc = document.getElementById('text_color');
    if (tc && T.defaultFg) tc.value = T.defaultFg;
    // pictogram on/off, saved on the order
    var anchor = document.querySelector('.product_text_color_wrapper') || (cs && cs.closest('.product_variation_field'));
    if (anchor && !document.getElementById('cm_tape_picto')) {
      var wrap = document.createElement('div');
      wrap.className = 'product_variation_field row mb-4 align-items-center';
      wrap.innerHTML = '<div class="col-12"><label class="cm_tape_picto_label"><input type="checkbox" id="cm_tape_picto" name="properties[Pictogram]" value="Do not drink pictogram"' + (T.pictoDefault ? ' checked' : '') + '> Add the &ldquo;do not drink&rdquo; pictogram</label></div>';
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
      var cb = wrap.querySelector('input');
      // unchecked boxes are not submitted, so a hidden "No" keeps the choice on the order either way
      var hid = document.createElement('input'); hid.type = 'hidden'; hid.name = 'properties[Pictogram]'; hid.value = 'None';
      wrap.insertBefore(hid, wrap.firstChild);
      var sync = function () { hid.disabled = cb.checked; };
      cb.addEventListener('change', function () { sync(); queue(); }); sync();
    }
  }
  function setupStock() {
    if (!T.legendOption) return;
    var s = optSel(T.legendOption);
    if (s) { var row = s.closest('.product_variation_field'), lab = row && row.querySelector('label'); if (lab) lab.textContent = T.legendLabel || 'Legend'; }
  }

  function init() {
    setupCustom(); setupStock();
    document.addEventListener('change', queue, true);
    document.addEventListener('input', queue, true);
    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measureSvg = null; render(); });
    setTimeout(render, 600); setTimeout(render, 1600);
    window.addEventListener('resize', queue);
    window.cmTapeRender = render;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
